import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { NGXLogger, NgxLoggerLevel, INGXLoggerConfig } from 'ngx-logger';

import { EnableClassTelemetry } from 'app/services/otel.service';

export enum LoggerLevel {
  TRACE = 0,
  DEBUG = 1,
  INFO = 2,
  LOG = 3,
  WARN = 4,
  ERROR = 5,
  FATAL = 6,
  OFF = 7,
}

export interface LoggerAdditional {
  [key: string]: any;
}

export interface LoggerConfiguration {
  level: LoggerLevel;
  serverLogLevel?: LoggerLevel;
  serverLoggingUrl?: string;
  headers?: HttpHeaders;
}

@EnableClassTelemetry()
@Injectable()
export class LoggerService {
  constructor(private logger: NGXLogger) {}

  public updateConfig(config: LoggerConfiguration): void {
    const ngxConfig: INGXLoggerConfig = {
      level: (config.level as unknown as NgxLoggerLevel) || NgxLoggerLevel.DEBUG,
      serverLogLevel: (config.serverLogLevel as unknown as NgxLoggerLevel) || NgxLoggerLevel.ERROR,
      serverLoggingUrl: config.serverLoggingUrl,
      customHttpHeaders: config.headers,
    };
    console.debug('updateConfig', ngxConfig);
    this.logger.updateConfig(ngxConfig);
  }

  public error(message: string, additional?: LoggerAdditional): void {
    this.logger.error(message, additional);
  }

  public warn(message: string, additional?: LoggerAdditional): void {
    this.logger.warn(message, additional);
  }

  public info(message: string, additional?: LoggerAdditional): void {
    this.logger.info(message, additional);
  }

  public debug(message: string, additional?: LoggerAdditional): void {
    this.logger.debug(message, additional);
  }
}
